module.exports = __webpack_public_path__ + "static/Overton_Impulse_FINAL.87960a0b.webm";


//////////////////
// WEBPACK FOOTER
// ./src/img/stories/richard_overton/Overton_Impulse_FINAL.webm
// module id = 369
// module chunks = 94818538752247